import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core"
import { t } from "ttag"
import { PrimaryButton } from "@humanpredictiveintelligence/myqvt-library"
import React from "react"

export const CancelChangesDialog: React.FC<CancelChangesDialogProps> = ({ isOpen, onCancel, onConfirm }) => (
  <Dialog open={isOpen}>
    <DialogTitle>{t`Quit page and cancel all changes`}</DialogTitle>
    <DialogContent>
      {t`Your survey has unsaved changes. If you confirm, you will lose your changes.`}
    </DialogContent>
    <DialogActions>
      <PrimaryButton destructive onClick={onConfirm}>
        {t`Confirm`}
      </PrimaryButton>
      <PrimaryButton onClick={onCancel}>
        {t`Cancel`}
      </PrimaryButton>
    </DialogActions>
  </Dialog>
)

interface CancelChangesDialogProps {
  isOpen: boolean,
  onConfirm: () => void,
  onCancel: () => void,
}
